module.exports = __webpack_public_path__ + "img/webpay.b00dca9e.png";